"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9362],{

/***/ 43354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": function() { return /* binding */ ErrorModal; },
/* harmony export */   "VF": function() { return /* binding */ AlertModal; }
/* harmony export */ });
/* unused harmony export ModalDialogContentText */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26993);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1890);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68346);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13264);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60031);
/*
 * File: Modal.tsx
 * Project: @inventures/react-lib
 * File Created: Wednesday, 23rd September 2020 4:10:47 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Wednesday, 12th July 2023 6:57:54 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2020 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 










var IconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({
    position: "relative",
    height: "14px",
    width: "14px",
    marginLeft: "90%",
    marginTop: "20px"
});
var Container = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({});
var DialogTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "150%",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "center",
    marginBottom: "12px"
});
var DialogContentText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "150%",
    letterSpacing: "-0.011em",
    textAlign: "center",
    color: "#414046",
    margin: "0px 18px 12px 18px"
});
var DialogActions = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "direction";
    }
})(function(param) {
    var direction = param.direction;
    return {
        display: "flex",
        flexDirection: direction || "column",
        alignItems: "center",
        padding: direction === "row" ? "16px" : "17px 0px",
        gap: direction === "row" ? "16px" : "0px"
    };
});
var ButtonAction = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    borderRadius: "100px",
    height: "42px",
    width: "199px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textDecoration: "none",
    textTransform: "none"
});
var Pointer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({
    cursor: "pointer"
});
var ModalDialog = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "changeDialogPaper";
    }
})(function(param) {
    var changeDialogPaper = param.changeDialogPaper;
    return {
        "& .MuiDialog-paper": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            margin: 16,
            maxWidth: 336
        }, changeDialogPaper ? {
            width: "100%",
            minHeight: 197
        } : {})
    };
});
var ModalDialogContentText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DialogContentText, {
    shouldForwardProp: function(prop) {
        return prop !== "alingContentLeft";
    }
})(function(param) {
    var alignContentLeft = param.alignContentLeft;
    return {
        textAlign: alignContentLeft ? "left" : "center",
        whiteSpace: "pre-line"
    };
});
function AlertModal(props) {
    var title = props.title, open = props.open, content = props.content, children = props.children, actions = props.actions, actionsDirection = props.actionsDirection, setOpen = props.setOpen, onClose = props.onClose, disableEscapeKeyDown = props.disableEscapeKeyDown, onBackdropClick = props.onBackdropClick, AlignContentLeft = props.AlignContentLeft, changeDialogPaper = props.changeDialogPaper, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, [
        "title",
        "open",
        "content",
        "children",
        "actions",
        "actionsDirection",
        "setOpen",
        "onClose",
        "disableEscapeKeyDown",
        "onBackdropClick",
        "AlignContentLeft",
        "changeDialogPaper"
    ]);
    var handleClose = function() {
        if (onClose) onClose();
        else if (actions.length === 1) actions[0].onActionClick();
        setOpen(false);
    };
    var haveHandleClose = (actions === null || actions === void 0 ? void 0 : actions.length) === 1 || onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialog, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, otherProps), {
        open: open,
        onClose: handleClose,
        changeDialogPaper: changeDialogPaper,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onBackdropClick: onBackdropClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
                    children: haveHandleClose && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pointer, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            layout: "fill",
                            src: "/assets/images/home/closeicon.webp",
                            alt: "closeIcon",
                            objectFit: "contain",
                            onClick: handleClose
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogTitle, {
                    children: title
                }),
                content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialogContentText, {
                    alignContentLeft: AlignContentLeft,
                    children: content
                }),
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogActions, {
                    direction: actionsDirection,
                    children: actions === null || actions === void 0 ? void 0 : actions.map(function(action, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonAction, {
                            onClick: action.onActionClick,
                            color: "primary",
                            variant: action.variant,
                            children: action.text
                        }, index);
                    })
                })
            ]
        })
    }));
}
function ErrorModal(props) {
    var open = props.open, title = props.title, description = props.description, handleBack = props.handleBack, whatsappText = props.whatsappText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AlertModal, {
        title: title,
        open: open,
        setOpen: function() {},
        disableEscapeKeyDown: true,
        disableBackdropClick: true,
        actions: [
            {
                text: "Aceptar",
                onActionClick: handleBack,
                variant: "contained"
            }, 
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ModalDialogContentText, {
            children: [
                description,
                ", intenta nuevamente o",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    target: "_blank",
                    href: "https://api.whatsapp.com/send?phone=".concat(_config_environment__WEBPACK_IMPORTED_MODULE_3__/* .PHONE_NUMBER.CLEAN */ .UE.CLEAN, "&text=").concat(encodeURI(whatsappText)),
                    children: "cont\xe1ctanos para recibir ayuda"
                })
            ]
        })
    });
}


/***/ }),

/***/ 78459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ AssistantButton; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Fab/Fab.js + 1 modules
var Fab = __webpack_require__(10160);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/order/mutations/createOrder.tsx
/*
 * File: createOrder.tsx
 * Project: meki
 * File Created: Wednesday, 4th November 2020 11:08:37 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Thursday, 29th April 2021 12:46:47 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ",
        " {\n    createOrder {\n      id\n      uuid\n      orderDetails {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CreateOrderMutation = function(name) {
    return (0,lib/* gql */.Ps)(_templateObject(), name);
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/toast.hook.tsx + 4 modules
var toast_hook = __webpack_require__(11263);
// EXTERNAL MODULE: ./src/components/Modal.tsx
var Modal = __webpack_require__(43354);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/screens/home/components/AssistantButton.tsx
/*
 * File: AssistantButton.tsx
 * Project: meki
 * File Created: Wednesday, 29th December 2021 4:39:13 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Thursday, 24th November 2022 4:10:32 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
















var FloatingAssistantButton = dynamic_default()(function() {
    var promise = Promise.all(/* import() */[__webpack_require__.e(1543), __webpack_require__.e(4918), __webpack_require__.e(4645)]).then(__webpack_require__.bind(__webpack_require__, 4645)).then(function(mod) {
        return mod.FloatingAssistantButton;
    });
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4645)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return null;
    }
});
var AssistantCreateNewOrderFab = (0,styled/* default */.Z)(Fab/* default */.Z)({
    position: "fixed",
    right: 15,
    bottom: 70
});
function AssistantButton() {
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var toasts = (0,toast_hook/* useToast */.p)();
    // App state
    var setOrderUuid = (0,useOrderState/* useOrderState */.h)().setOrderUuid;
    var setUserEmail = (0,useMekiState/* useMekiState */.c)().setUserEmail;
    // Local state
    var ref = (0,react.useState)(false), newOrderModal = ref[0], setNewOrderModal = ref[1];
    // Other vars
    var isAssistant = userCan("MANAGE_USER");
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CreateOrderMutation("assistantCreateOrderHome")), 2), mutate = ref1[0], loading = ref1[1].loading;
    if (!isAssistant) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingAssistantButton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AssistantCreateNewOrderFab, {
                color: "primary",
                variant: "extended",
                onClick: function() {
                    return setNewOrderModal(true);
                },
                disabled: loading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {}),
                    "Cotizaci\xf3n"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* AlertModal */.VF, {
                title: "Nueva cotizaci\xf3n ⚠️",
                content: "Se crear\xe1 una nueva cotizaci\xf3n vacia y no podr\xe1s acceder a la anterior",
                open: newOrderModal,
                setOpen: setNewOrderModal,
                onClose: function() {
                    return setNewOrderModal(false);
                },
                actions: [
                    {
                        text: "CANCELAR",
                        onActionClick: function() {
                            return setNewOrderModal(false);
                        }
                    },
                    {
                        text: "confirmar",
                        onActionClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var ref, _data, order;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setNewOrderModal(false);
                                        setUserEmail("");
                                        return [
                                            4,
                                            mutate()
                                        ];
                                    case 1:
                                        ref = _state.sent(), _data = ref.data, order = _data.createOrder;
                                        utils/* Console.log */.Mn.log({
                                            msg: "[Home] change order uuid",
                                            orderUuid: order.uuid
                                        });
                                        setOrderUuid(order.uuid);
                                        toasts.showToast({
                                            message: "Inicio de nueva cotizaci\xf3n",
                                            type: "success"
                                        });
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        variant: "contained"
                    }, 
                ]
            })
        ]
    });
}


/***/ }),

/***/ 88617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ HomeNavBar; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(20784);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(26993);
;// CONCATENATED MODULE: ./src/screens/home/components/homeNavBar.styles.ts
/*
 * File: homeNavBa
 * Project: meki
 * File Created: Thursday, 28th July 2022 4:01:26 pm
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 18th January 2023 12:23:58 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2022 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 


var RootDiv = (0,styled/* default */.Z)("div")({
    flexGrow: 1,
    "& .MuiButton-root": {
        textTransform: "None"
    },
    position: "sticky",
    top: 0,
    zIndex: 1100
});
var HeaderAppBar = (0,styled/* default */.Z)(AppBar/* default */.Z)(function(param) {
    var theme = param.theme, elevation = param.elevation;
    return {
        top: 0,
        bottom: "auto",
        height: 64,
        background: theme.palette.common.white,
        boxShadow: elevation ? "0px 1px 10px rgb(0 0 0 / 12%)" : "none",
        transition: "background-color 0.4s",
        backdropFilter: "blur(5px)",
        "@media (min-width: 800px)": {
            height: "inherit"
        },
        position: "relative"
    };
});
var HeaderToolbar = (0,styled/* default */.Z)(Toolbar/* default */.Z)({
    justifyContent: "space-between",
    minHeight: 64,
    backgroundColor: "transparent",
    paddingRight: 0,
    paddingLeft: "12px"
});
var PositionDivLeft = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        flex: 0,
        position: "absolute",
        left: 20,
        zIndex: 1
    }, theme.breakpoints.down("md"), {
        zIndex: 0,
        left: 0,
        position: "unset"
    });
});
var PositionDivRight = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        flex: 0,
        position: "absolute",
        right: 12,
        zIndex: 1
    }, theme.breakpoints.down("md"), {
        zIndex: 3000,
        right: 0,
        position: "unset"
    });
});
var HeaderLeftDiv = (0,styled/* default */.Z)("div")({
    zIndex: 0,
    display: "flex",
    alignItems: "center"
});
var BackIconButton = (0,styled/* default */.Z)(IconButton/* default */.Z)(function() {
    return {
        color: "#004C8C"
    };
});
var HeaderRightComponent = (0,styled/* default */.Z)("div")({
    display: "flex",
    alignItems: "center"
});
var MekiLogoDiv = (0,styled/* default */.Z)("div")({
    cursor: "pointer",
    marginLeft: 9,
    display: "flex"
});
var LoginButton = (0,styled/* default */.Z)(Button/* default */.Z)(function() {
    return {
        color: "#414046",
        borderColor: "#414046",
        height: 19,
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "1px",
        maxWidth: 180,
        textDecoration: "underline",
        "@media (max-width: 767px)": {
            fontSize: 12
        }
    };
});


// EXTERNAL MODULE: ./src/screens/menu/index.tsx
var menu = __webpack_require__(85393);
// EXTERNAL MODULE: ./src/components/icons/LogoMeki.tsx
var LogoMeki = __webpack_require__(73604);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(71096);
// EXTERNAL MODULE: ./src/screens/cart/DrawerCart.tsx + 2 modules
var DrawerCart = __webpack_require__(24950);
// EXTERNAL MODULE: ./src/hooks/useFocusSearchBox.tsx
var useFocusSearchBox = __webpack_require__(31515);
// EXTERNAL MODULE: ./src/components/searchBox.tsx + 8 modules
var searchBox = __webpack_require__(14703);
// EXTERNAL MODULE: ./src/validators/Events/Interactions/index.ts + 5 modules
var Interactions = __webpack_require__(40813);
// EXTERNAL MODULE: ./src/hooks/useEventTracking.tsx + 1 modules
var useEventTracking = __webpack_require__(66630);
;// CONCATENATED MODULE: ./src/screens/home/components/homeNavBar.tsx















function HomeNavBar(param) {
    var isVisible = param.isVisible, setIsVisible = param.setIsVisible;
    var ref, ref1, ref2;
    var ref3 = (0,useWindowSize/* useWindowSize */.i)(), width = ref3.width, isDesktop = ref3.isDesktop;
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    var ref4 = (0,useAuth/* useAuth */.a)(), user = ref4.appUser;
    var router = (0,next_router.useRouter)();
    var focusSearchBox = (0,useFocusSearchBox/* useFocusSearchBox */.G)();
    var ref5 = (0,react.useState)(false), hideInfo = ref5[0], setHideInfo = ref5[1];
    var elevation = 1;
    (0,react.useEffect)(function() {
        if (isVisible && !isDesktop) {
            setHideInfo(true);
            return;
        }
        setHideInfo(false);
    }, [
        focusSearchBox,
        isVisible,
        isDesktop
    ]);
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderAppBar, {
            color: "primary",
            elevation: elevation,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderToolbar, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionDivLeft, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderLeftDiv, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* DrawerMenu */.O, {}),
                                !hideInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(MekiLogoDiv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoMeki/* MekiLogo */.$, {
                                        fill: "#414046",
                                        height: "24px",
                                        width: "auto",
                                        onClick: function() {
                                            void router.push((0,utils/* getRoute */.Bv)("home"));
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(searchBox/* SearchBox */.R, {
                        isHeader: true,
                        isVisible: isVisible,
                        setIsVisible: setIsVisible
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionDivRight, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderRightComponent, {
                            children: [
                                !hideInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: !user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton, {
                                        size: "medium",
                                        onClick: function() {
                                            track(Interactions/* InteractionEventTypes.ClickLogin */.P.ClickLogin, {
                                                location: "navbar"
                                            });
                                            void router.push({
                                                pathname: "/ingresar",
                                                query: (0,utils/* removeUndefineds */.ox)((0,_object_spread/* default */.Z)({}, router.query))
                                            }, {
                                                pathname: "/ingresar"
                                            });
                                        },
                                        children: width >= 1110 ? "Iniciar sesi\xf3n" : "Inicia"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* DrawerMenu */.O, {
                                        isFromMenuName: "".concat((ref = user.name) === null || ref === void 0 ? void 0 : ref.split(" ")[0], " ").concat((ref6 = (ref1 = user.lastNames) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.toLocaleUpperCase()) !== null && ref6 !== void 0 ? ref6 : "", ".")
                                    })
                                }),
                                (isDesktop || !isDesktop && !focusSearchBox.isFocus) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerCart/* DrawerCart */.$, {})
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 9762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ CategoriesCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/home/landing/HeroSection/style/categoryCard.style.tsx



var CategoriesCardContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme, logIn = param.logIn;
    var _obj;
    return _obj = {
        zIndex: 10,
        display: "flex",
        flexDirection: "row",
        gap: 30,
        overflowX: "auto",
        padding: logIn ? "32px 4%" : 10,
        justifyContent: logIn ? "flex-start" : "center"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        padding: logIn ? "20px 20px" : "0px 20px",
        gap: 10,
        justifyContent: "left"
    }), (0,_define_property/* default */.Z)(_obj, "scrollbarWidth", "none"), (0,_define_property/* default */.Z)(_obj, "-ms-overflow-style", "none"), (0,_define_property/* default */.Z)(_obj, "&::-webkit-scrollbar", {
        display: "none"
    }), _obj;
});
var CategoryCardContainer = (0,styled/* default */.Z)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        backgroundColor: "#FFFFFF",
        width: 200,
        height: 176,
        padding: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        borderRadius: 8,
        flex: "0 0 auto",
        cursor: "pointer",
        boxShadow: "0px 0px 12px rgba(0,0,0,0.3)",
        marginTop: "4px"
    }, theme.breakpoints.down("md"), {
        width: "148px",
        height: "140px",
        padding: 4
    });
});
var CategoryCardTitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: 18,
        fontWeight: 600,
        color: "#414046",
        textAlign: "center",
        fontFamily: "Poppins",
        whiteSpace: "pre-wrap",
        padding: "0px 10px"
    }, theme.breakpoints.down("md"), {
        fontSize: 14,
        maxWidth: 120
    });
});


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/screens/home/landing/HeroSection/categoriesCard.tsx






var categories = [
    {
        name: "Medicamentos",
        image: "/assets/images/newLanding/CategoriesMenu/Medicamentos.svg",
        slug: "medicamentos"
    },
    {
        name: "Cuidado personal",
        image: "/assets/images/newLanding/CategoriesMenu/CuidadoPersonal.svg",
        slug: "cuidado-personal"
    },
    {
        name: "Belleza",
        image: "/assets/images/newLanding/CategoriesMenu/Belleza.svg",
        slug: "belleza"
    },
    {
        name: "Vitaminas y suplementos",
        image: "/assets/images/newLanding/CategoriesMenu/VitySupl.svg",
        slug: "vitaminas-y-suplementos"
    },
    {
        name: "Mascotas",
        image: "/assets/images/newLanding/CategoriesMenu/Mascotas.svg",
        slug: "veterinaria"
    }, 
];
var CategoriesCard = function() {
    var router = (0,next_router.useRouter)();
    var currentLocation = (0,react.useMemo)(function() {
        return router.asPath.includes("inicio");
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesCardContainer, {
        logIn: currentLocation,
        children: categories.map(function(category) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCardContainer, {
                onClick: function() {
                    void router.push((0,utils/* getRoute */.Bv)("subCategories", {
                        categorySlug: category.slug
                    }));
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: category.image,
                        alt: category.name,
                        width: 78,
                        height: 78
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCardTitle, {
                        children: category.name
                    })
                ]
            }, category.name);
        })
    });
};


/***/ })

}]);